import { render, staticRenderFns } from "./UsuarioDeposito.vue?vue&type=template&id=1bace4b2&"
import script from "./UsuarioDeposito.vue?vue&type=script&lang=js&"
export * from "./UsuarioDeposito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports